import { render, staticRenderFns } from "./DefaultGlobalSettings.vue?vue&type=template&id=52b24a5b&scoped=true&"
import script from "./DefaultGlobalSettings.vue?vue&type=script&lang=js&"
export * from "./DefaultGlobalSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b24a5b",
  null
  
)

export default component.exports